import { render } from "./bank-accounts.vue?vue&type=template&id=3be4a0ec&scoped=true"
import script from "./bank-accounts.vue?vue&type=script&lang=js"
export * from "./bank-accounts.vue?vue&type=script&lang=js"

import "./bank-accounts.vue?vue&type=style&index=0&id=3be4a0ec&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be4a0ec"]])

export default __exports__